import axios from 'axios';
import { getHostname } from './server/server'

const hostname = getHostname();
const path = '/v2/app';

const getLocalAppVersion = async (customerId) => {
    const res = await axios.get(`${hostname}${path}/localAppVersion?customerId=${customerId}`);
    return res.data;
}

const buildLocalApp = async (customerId) => {
    const res = await axios.put(`${hostname}${path}/buildLocalApp?customerId=${customerId}`);
    return res.data;
}

export {
    getLocalAppVersion,
    buildLocalApp
}